import { AppListenerMiddleware, RootState } from "@src/store";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { getPageState } from "@src/store/slices/experienceBuilder/common/selectors/getPageState";
import { selectedExperience } from "@src/store/slices/experiences";
import mixpanel from "mixpanel-browser";

const { getLocation, getLastLocation } = experienceBuilderSlice.selectors;

export const setupPreviewErrorListener = (middleware: AppListenerMiddleware) =>
  middleware.startListening({
    predicate: (_, curr, prev) => predicate(curr, prev),
    effect: (_, { getState }) => {
      const state = getState();
      const location = getLocation(state);
      const experience = selectedExperience(state);
      const error = getPageState(state);
      if (error?.type === "proxyTimeout") {
        mixpanel.track("visual_builder_unsupported_location_shown", {
          location,
          last_location: getLastLocation(state),
          experience_id: experience.id,
        });
      } else if (error?.type === "pluginTimeout") {
        mixpanel.track("visual_builder_missing_script_shown", {
          location,
          last_location: getLastLocation(state),
          experience_id: experience.id,
        });
      }
    },
  });

const predicate = (state: RootState, prev: RootState) => {
  const current = getPageState(state);
  const previous = getPageState(prev);
  return Boolean(
    (current?.type === "proxyTimeout" || current?.type === "pluginTimeout") &&
    current.type !== previous?.type
  );
};
